import React, { useEffect } from 'react';
import { CommentSummaryPopup } from '@pearsontechnology/aero-components';
import { scheduleForExecution } from 'services/AnnotationService/lazyLoadingExecutor';

function CommentSummary({ annotationService, rootElementId, elementId }) {
  const [summary, setSummary] = React.useState({ unRead: 0, unResolved: 0, resolved: 0, total: 0 });

  useEffect(() => {
    const getSummary = async () => {
      try {
        const response = await annotationService.authorAnnotationAggregate({
          rootElementId,
          elementId,
        });
  
        const aggregate = response.coursewareAnnotationAggregate ?? {};
  
        const aggregateResult = {
          total: aggregate.total ?? 0,
          unRead: aggregate.unRead ?? 0,
          resolved: aggregate.resolved ?? 0,
          unResolved: aggregate.unResolved ?? 0,
        };
  
        setSummary(aggregateResult);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(`Fetching annotation aggregate failed: ${error}`);
      }
    };
  
    scheduleForExecution(getSummary());
  }, [annotationService, elementId, rootElementId]);
  
  
  return (
    <>
      {summary.total > 0 && <CommentSummaryPopup
        unread={summary.unRead}
        unresolved={summary.unResolved}
        resolved={summary.resolved}
        bubbleIndicator={true} />
      }
    </>
  );
}

export default CommentSummary;